export default {
  api: {
    url: 'https://api.perfoplanning.com',
    auth: {
      token: 'b09a48b097d6fff176746a0389aZw90b',
      signature: '2871dae4de36853634fc2e2339fe0db7caff644c'
    }
  },
  app: {
    url: 'https://app.perfoplanning.com'
  },
  site: {
    URLPlans: 'https://perfoplanning.com/tarifs/',
    URLDemo: 'https://perfoplanning.com/contact',
    URLTerms: 'https://perfoplanning.com/politiques'
  },
  defaultAvatarUrl: '/assets/img/default-avatar.png',
  defaultProductImgUrl: '/assets/img/default-product.jpg',
  modal: {
    lazy: true,
    static: false
  }
}
